import React, { useEffect, useState } from "react";
import { notification } from 'antd';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

import axios from 'axios';


import { rootURL } from "../constants";

const VerifyEmail: React.FC = () => {

    const navigate = useNavigate(); // Use useNavigate hook
    useEffect(() => {
      const params = new URLSearchParams(window.location.search);
      const token = params.get("token");


      if (token) {
          axios.get(`${rootURL}/authentication/verify-email/?token=${token}`)
              .then((response) => {
                  if (response.status === 200) {
                     
                      
                      navigate('/', { 
                          state: { 
                              message: "Your email has been verified successfully!" 
                          } 
                      }); 
                  } else {
                      notification.error({
                          message: 'Email Verification Failed',
                          description: "Email verification failed. " + (response.data.error || ""),
                      });
                      navigate('/login', { 
                          state: { 
                              message: "Email verification failed. " + (response.data.error || "") 
                          } 
                      });
                  }
              })
              .catch((error) => {
                  console.error("Error verifying email:", error);
                  notification.error({
                      message: 'Verification Error',
                      description: "Something went wrong. Please try again.",
                  });
                  navigate('/login', { 
                      state: { 
                          message: "Something went wrong. Please try again." 
                      } 
                  });
              });
      } else {
          notification.warning({
              message: 'Token Missing',
              description: "No verification token found.",
          });
          navigate('/login', { 
              state: { 
                  message: "No verification token found." 
              } 
          });
      }
  }, []);

  return null;
};

export default VerifyEmail;
